export default __webpack_public_path__ + "static/media/bkg--location-1.408d0bf8.jpg";